export default [
    {
        path: '/admin/companies',
        name: 'AdminCompanies',
        component: () => import('@/views/Admin/Companies.vue'),
        meta: { superAdminOnly: true }
    },
    {
        path: '/admin/companies/create',
        name: 'CreateCompany',
        component: () => import('@/views/Admin/CompanyBuilder.vue'),
        meta: { superAdminOnly: true }
    },
    {
        path: '/admin/companies/:id',
        name: 'Company',
        component: () => import('@/views/Admin/Company.vue'),
        meta: { superAdminOnly: true }
    },
    {
        path: '/admin/companies/:companyId/edit',
        name: 'EditCompany',
        component: () => import('@/views/Admin/CompanyBuilder.vue'),
        meta: { superAdminOnly: true }
    },
    {
        path: '/admin/templates',
        name: 'Templates',
        component: () => import('@/views/Admin/Templates.vue'),
        meta: { permission: 'response-templates.view' }
    },
    {
        path: '/admin/template/create',
        name: 'CreateTemplate',
        component: () => import('@/views/Admin/CreateTemplate.vue'),
        meta: { permission: 'response-templates.create' }
    },
    {
        path: '/admin/templates/:id/edit',
        name: 'EditTemplate',
        component: () => import('@/views/Admin/EditTemplate.vue'),
        meta: { permission: 'response-templates.update' }
    },
    {
        path: '/admin/news',
        name: 'AdminNews',
        component: () => import('@/views/Admin/News/GlobalNewsList.vue'),
        meta: { superAdminOnly: true }
    },
    {
        path: '/admin/news/new',
        name: 'AdminNewsCreate',
        component: () => import('@/views/Admin/News/GlobalNewsCreate.vue'),
        meta: { superAdminOnly: true }
    },
    {
        path: '/admin/news/:id/edit',
        name: 'AdminNewsEdit',
        component: () => import('@/views/Admin/News/GlobalNewsEdit.vue'),
        meta: { superAdminOnly: true }
    }
]
